import { Component, Input } from '@angular/core';

import { BaseSegmentComponent } from '../base/_base-segment.component';


@Component({
  moduleId: module.id,
  selector: 'fitments-segment',
  templateUrl: 'fitments.component.html',
  styleUrls: ['fitments.component.scss'],
})
export class FitmentsComponent extends BaseSegmentComponent {}
